import { render } from "./ReadViewer.vue?vue&type=template&id=4253e160"
import script from "./ReadViewer.vue?vue&type=script&lang=js"
export * from "./ReadViewer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__